export default {
  copyAddress: "آدرس کپی شد.",
  copy: "کپی شد",
  operationsPageDetails: [
    { to: "deposit", tooltip: "واریز" },
    { to: "withdrawal", tooltip: "برداشت‌" },
    { to: "exchange", tooltip: "تبدیل" },
    { to: "transfer", tooltip: "انتقال" }
  ],
  deposit: {
    to: "deposit",
    title: "واریز",
    historyOfDeposit: "تاریخچه واریزها",
    userNotVerify: {
      title: "شما احراز هویت نکرده‌اید",
      description: "جهت واریز ریالی، احراز هویت خود را تکمیل کنید",
      button: "تکمیل احراز هویت"
    },
    category: {
      crypto: {
        networkType: "نوع شبکه",
        networkTypeNotice: `نوع شبکه مشخص می‌کند که انتقال ارز در بستر چه شبکه ای باید انجام شود.برای انجام تراکنش موفق حتما باید در مبدا و مقصد شبکه یکسان انتخاب شود.`,
        address: "آدرس شبکه {address}",
        memo: "آدرس {memo} شبکه {address}",
        warningText:
          "برای واریز {name_locale} به آدرس خود حتما از آدرس و تگ {extra_name} {name_locale} به صورت همزمان استفاده کنید.",
        noAddress: "امکان واریز این رمزارز در حال حاضر وجود ندارد.",
        hintTitle: "فقط {iso} به این آدرس واریز کنید.",
        hintDescription:
          "ارسال ارز غیر از {iso} به این آدرس ممکن است منجر به از دست دادن آن شود.",
        networkRequestBtn: "درخواست دریافت آدرس شبکه",
        warningTitle: "هشدار",
        warningText1:
          "برای واریز این ارز حتما از آدرس و memo به صورت همزمان استفاده کنید.",
        warningText2: "در غیر این صورت دارایی شما از بین خواهد رفت.",
        acceptTermsText: "شرایط بالا را خواندم و پذیرفتم",
        confirmBtn: "تایید",
        copyAddress: "آدرس کپی شد."
      },
      rial: {
        paymentMethod: "شیوه واریز",
        paymentType: [
          { id: 0, field: "online_payment", route: "online", name: "درگاه" },
          {
            id: 5,
            field: "online_payment",
            route: "cart",
            name: "کارت به کارت"
          },
          {
            id: 2,
            field: "offline_payment_with_identifier",
            route: "paymentID",
            name: "واریز با شناسه"
          },
          {
            id: 1,
            field: "offline_payment",
            route: "offline",
            name: "واریز مستقیم"
          },
          // {
          //   id: 4,
          //   field: "offline_payment",
          //   route: "cartToCart",
          //   name: "کارت به کارت آفلاین"
          // },
          {
            id: 3,
            field: "direct_payment",
            route: "direct-debit",
            name: "شارژ فوری"
          }
        ],
        directDebit: {
          maxWithdrawText: "سقف روزانه: {amount} ریال",
          usageText: "میزان استفاده شده: {amount} ریال",
          expireText: "تاریخ انقضا قراداد:",
          newAccountBtn: "افزودن حساب جدید",
          immediateChargeBtn: "شارژ فوری",
          doNotHaveImmediateAccText:
            "تا کنون حسابی را برای شارژ فوری فعال نکرده‌اید.",
          shaparakRule:
            "با توجه به قوانین جدید شاپرک مجموع پرداخت روزانه از طریق درگاه‌های بانکی نمی‌تواند بیش از {amount} ریال باشد. برای واریز مبالغ بالاتر می‌توانید به راحتی از پرداخت با شناسه یا پرداخت آفلاین استفاده کنید.",
          activateImmediateChargeBtn: "فعال‌سازی شارژ فوری",
          removeImmediateChargeText: "حذف شارژ فوری ",
          cancelBtn: "انصراف",
          acceptRemovingBtn: "تایید حذف",
          copy: "کپی شد.",
          chooseBank: {
            maxWithdrawText: "سقف روزانه: {amount} ریال",
            continueBtn: "ادامه",
            cancelBtn: "انصراف"
          },
          createContractForm: {
            activateWithdrawText: "فعال سازی برداشت مستقیم از",
            maxAmountTrx: "سقف هر تراکنش",
            contractPreiod: "مدت قرارداد",
            cancelBtn: "انصراف",
            addContractBtn: "ایجاد قرارداد",
            successDeposit: "واریز ریالی شما با موفقیت انجام شد.",
            pendingDeposit: "واریز ریالی شمادر حال بررسی می‌باشد.",
            bankName: "نام بانک",
            depositAmount: "مبلغ واریزی",
            trxNumber: "شماره تراکنش",
            dateTitle: "تاریخ و زمان ثبت",
            walletBtn: "کیف پول",
            unSuccessfullTrxText: "تراکنش ناموفق",
            maxDailyRemainedText: "سقف مانده روزانه",
            immediateChargeBtn: "شارژ فوری"
          },
          directDebitTable: {
            immediateChargeHistoryTitle: "تاریخچه شارژ فوری"
          }
        },
        offline: {
          accountListTitle: "مشاهده شماره حساب‌های اکسکوینو",
          notice: {
            title: "توجه کنید",
            description:
              "لطفا در واریز آفلاین ریالی حتما موارد زیر را رعایت کنید؛ در غیر این صورت تراکنش شما معلق می‌شود.",
            firstRule: "1) کارت یا حساب‌های بانکی حتما به نام خودتان باشد.",
            secondRule:
              '2) هنگام پرداخت‌های پایا و ساتنا، حتما در قسمت بابت یا شرح، عبارت " تادیه دیون" را بنویسید.',
            thirdRule:
              "3) شناسه واریز، کد ملی شما می باشد. حتما در زمان واریز در بانک بر روی فیش بانکی آن را بنویسید.",
            fourthRule:
              "4) کد پیگیری واریز پایا و ساتنا با شماره سال جاری شروع (مثلا 1403) میشود لطفا در هنگام درج کد پیگیری دقت فرمایید.",
            badgeText:
              ' در واریزهای بانک شهر به بانک شهر، هنگام مراجعه حضوری به بانک یا استفاده از اپلیکیشن بانک شهر، علاوه بر نوشتن شناسه واریز، حتما در قسمت کد مرجع، عدد "90" را بنویسید.'
          },
          form: {
            title: "ثبت اطلاعات واریز آفلاین",
            amountInputLabel: "مبلغ واریزی",
            amountInputValidation: "مبلغ واریزی را وارد کنید.",
            depositType: "نوع واریز",
            selectLabel:
              "به کدام حساب واریز کرده‌اید؟ | به کدام کارت واریز کرده‌اید؟",
            noResult: "نتیجه‌ای یافت نشد.",
            selectValidation:
              "حساب بانکی را انتخاب کنید. | کارت بانکی را انتخاب کنید.",
            bankInputLabel: "بانک مبدا",
            bankInputValidation: "بانک مبدا را وارد کنید.",
            trackingInputLabel: "کدپیگیری",
            trackingInputValidation: "کدپیگیری را وارد کنید.",
            dateInputLabel: "تاریخ واریز",
            dateInputValidation: "تاریخ واریز را انتخاب کنید.",
            imageInputLabel: "تصویر فیش واریزی",
            imageInputValidation: "فیش واریزی را آپلود کنید.",
            button: "ثبت"
          },
          offlineTable: {
            title: "تاریخچه واریز ریالی آفلاین",
            tableHeader: {
              paymentDate: "تاریخ پرداخت",
              amount: "مبلغ واریزی (ریال)",
              action: "عملیات",
              bankName: "نام بانک",
              referBankCode: "شماره ارجاع بانکی",
              providerReferCode: "شماره ارجاع ارائه دهنده",
              status: "وضعیت"
            }
          },
          accountList: {
            accountOwner: "نام صاحب حساب",
            accountNumber: "شماره حساب",
            depositId: "شناسه واریز",
            cardNumber: "شماره کارت",
            copyAccount: "شماره حساب کپی شد.",
            copyDeposit: "شناسه واریز کپی شد."
          }
        },
        online: {
          warningDescription:
            "با توجه به قوانین شاپرک، لطفاً توجه داشته باشید که حداکثر مجموع مبالغ پرداختی روزانه از طریق درگاه‌های بانکی، مبلغ 250,000,000 ریال می باشد. در صورت نیاز به واریز مبالغ بیشتر، شما می‌توانید به سادگی از امکان واریز با شناسه استفاده کنید. این روش علاوه بر تسریع در فرآیند واریز، سرعت بیشتری در افزایش اعتبار را نسبت به روش‌های آفلاین به شما ارائه می‌دهد.",
          warningLink: "واریز با شناسه",
          availableBalance: "موجودی فعلی شما",
          amount: "مبلغ واریزی",
          creditPortal: "از طریق درگاه اعتباری",
          bankPortal: "از طریق درگاه اینترنتی",
          button: "ادامه فرآیند واریز ریالی",
          minBalanceError: "حداقل مقدار مجاز {min} است.",
          maxBalanceError: "",
          maximumText: "حداکثر",
          canNotBeLessAmount: "مبلغ نمی‌تواند کمتر از {amount} ریال باشد",
          canNotBeMoreAmount: "مبلغ نمی‌تواند بیشتر از {amount} ریال باشد",
          cardSelectionPlaceholder: "انتخاب کارت بانکی",
          addCard: "افزودن کارت",
          addNewCard: "افزودن کارت بانکی جدید",
          feeInfo:
            "به دلیل کارمزد بعضی از درگاه‌ها، گاهی مبلغی که پرداخت می‌کنید کمی بیشتر از مقداری است که وارد کرده‌اید. لطفا توجه داشته باشید که اکسکوینو سهمی از این کارمزد ندارد."
        },
        paymentId: {
          checkDepositId: `
              <ul>
              <p>لطفاً پیش از هر واریز به اکسکوینو، حتماً به دو نکته توجه کنید:</p>
              <li>۱.شماره شبا را با دقت بررسی کنید. (ممکن است در هر واریز شماره شبا متفاوت باشد)</li>
              <li>۲.کد ملی شما همان شناسه واریز شماست، حتماً هنگام واریز در قسمت "شناسه واریز"، کد ملی خودتان را وارد کنید.</li>
              <li> ۳.استفاده از شناسه نادرست یا شماره شبا اشتباه ممکن است باعث برگشت یا تأخیر در واریز شود.</li>
              <li> ۴.در صورتی که واریز از بانکی انجام شود که با بانک‌های اکسکوینو یکسان باشد، به دلیل انتقال داخلی، شارژ حساب کاربری با سرعت بیشتری انجام خواهد شد.</li>
              </ul>`,
          watchGuideVideo: "مشاهده ویدیو راهنما",
          close: "بستن",
          receiveDepositId: "دریافت شناسه واریز",
          depositId: "شناسه واریز",
          requiredDepositId: "ثبت شناسه هنگام واریز الزامی است.",
          depositNumber: "شماره حساب",
          depositSheba: "شماره شبا",
          paymentIdTable: {
            depositHistoryTitle: "تاریخچه واریز ریالی با شناسه"
          },
          dialogText:
            " امکان واریز از  طریق کارت های ادغامی و ثبت آنها  در حساب کاربری میسر نمیباشد"
        }
      }
    }
  },
  withdraw: {
    to: "withdrawal",
    title: "برداشت‌",
    withdrawHistoryTitle: "تاریخچه برداشت‌ها",
    otp: {
      title: {
        text1: "هنوز تایید با",
        text2: "را فعال نکرده‌اید",
        text3: "یکی از مقادیر مورد نیاز تأیید نشده است"
      },
      description: {
        text1:
          "برای افزایش امنیت هنگام برداشت رمز ارز، از بخش تنظیمات حساب کاربری، باید",
        text2: "خود را تایید کنید."
      }
    },
    category: {
      crypto: {
        networkType: "نوع شبکه",
        networkTypeNotice: `نوع شبکه مشخص می‌کند که انتقال ارز در بستر چه شبکه ای باید انجام شود.برای انجام تراکنش موفق حتما باید در مبدا و مقصد شبکه یکسان انتخاب شود.`,
        addressLabel: "آدرس",
        addNewAddress: "افزودن آدرس جدید",
        submitBtn: "ادامه فرآیند برداشت رمز ارز",
        inventory: "موجودی قابل برداشت",
        transferFee: "کارمزد انتقال",
        amountReceived: "مقدار خالص دریافتی",
        warningText:
          "برای برداشت {name_locale} به آدرس خود حتما از آدرس و تگ {extra_name} {name_locale} به صورت همزمان استفاده کنید.",
        noAddress: "امکان برداشت این رمزارز در حال حاضر وجود ندارد.",
        addressNotCorrect: "آدرس وارد شده صحیح نیست.",
        mobileValidate: {
          title: "برای برداشت رمزارز نیاز به ثبت شماره موبایل دارید.",
          description:
            "برای برداشت رمزارز نیاز به ثبت شماره موبایل دارید.برای امنیت بیشتر در برداشت رمز ارز نیاز به تایید شماره موبایل خود دارید. لطفا به صفحه تنظیمات حساب کاربری رفته و شماره موبایل خود را تایید کرده و مجدد برای انجام عملیات برداشت اقدام کنید."
        },
        setting: "تنظیمات حساب کاربری",
        doNotNeedExtraName: "نیاز به {extraName} نیست",
        addAddressCard: {
          addNewAddress: "افزودن آدرس جدید",
          selectNetwork: "انتخاب شبکه",
          title: "عنوان",
          walletAddress: "آدرس کیف پول",
          add: "افزودن"
        },
        cancelOrderCard: {
          areYouSure: "آیا مطمئن هستید می‌خواهید لغو کنید؟",
          waitFor2Min:
            "در صورت لغو تا 2 دقیقه امکان ثبت آدرس جدید نخواهید داشت.",
          sureCancel: "مطمئنم، لغو کن",
          canecelation: "انصراف از لغو"
        },
        deleteAddressCard: {
          deleteWalletAddress: "حذف آدرس کیف پول",
          areYouSure: "آیا مطمئن هستید می‌خواهید این آدرس را حذف کنید؟",
          sureDelete: "مطمئنم، حذفش کن",
          canecelation: "انصراف از حذف"
        },
        extraFeeCard: {
          increasedFee: "کارمزد سفارش شما افزایش یافت",
          continueOrder: "متوجه شدم، ادامه ثبت سفارش",
          cancel: "لغو سفارش"
        },
        otpCard: {
          confirmCodeTitle: "کد تایید",
          enterCode:
            "برای افزودن آدرس، لطفا کد ارسال شده به (<span class='font-Bold-14' >{phoneNumber}</span >) را وارد کنید.",
          receiveCodeAgain: "دریافت مجدد کد تایید",
          continue: "ادامه",
          remainTime: "ارسال مجدد کد تا {second} ثانیه دیگر"
        },
        sendMobileCard: {
          securityConfirm: "تایید امنیتی",
          areYouSure: "آیا مطمئن هستید می‌خواهید این آدرس را حذف کنید؟",
          mobileNumber: "شماره موبایل",
          continue: "ادامه"
        },
        tagCard: {
          useFrom: "استفاده از {extraName}",
          useMemo:
            "برای {typeOfTransaction} {name_locale}، حتما از آدرس و {extra_name} {{name_locale}} به صورت همزمان استفاده کنید.",
          understood: "متوجه شدم"
        },
        steps: {
          step1: "انتخاب رمز ارز",
          step2: "انتخاب آدرس"
        }
      },
      rial: {
        withdrawType: "نوع برداشت",
        yourInventory: "موجودی فعلی شما",
        withdrawLabel: "مبلغ برداشتی",
        shebaLabel: "شماره شبا",
        cardNumberLabel: "شماره کارت",
        addShebaNumber: "افزودن شماره شبا جدید",
        addCardNumber: "افزودن شماره کارت جدید",
        shebaNumberHint:
          "لطفا شماره شبای مورد نظر خود را انتخاب و یا اضافه کنید",
        cardNumberHint:
          "لطفا شماره کارت مورد نظر خود را انتخاب و یا اضافه کنید",
        continueBtn: "ادامه فرآیند برداشت ریالی",
        cardToCardText:
          "درحال حاضر برداشت بصورت واریز به کارت امکان پذیر نیست.",
        authenticationTitle: "شما احراز هویت نکرده‌اید",
        authenticationDescription:
          "جهت برداشت ریالی، احراز هویت خود را تکمیل کنید",
        authenticationBtn: "تکمیل احراز هویت",
        sendAgainBtn: "دریافت مجدد کد تایید",
        receive: "دریافت میکنید",
        accountName: "نام دارنده حساب",
        transactionStatus: "مشاهده وضعیت تراکنش‌ها",
        submitTime: "تاریخ و زمان ثبت",
        mobileCodeText: {
          text1: "برای تایید درخواست برداشت، لطفا کد ارسال شده به (",
          text2: ") را وارد کنید."
        },
        rulesText: {
          text1: "ضمن انجام این سفارش تایید میکنم",
          excoinoLink: "قوانین سایت اکسکوینو",
          text2: "را مطالعه کرده و می پذیرم."
        },
        toWithdrawLessThan: "برای برداشت کمتر از {amount} میلیون تومان",
        fee: "کارمزد: 50,000 ریال",
        defineShaba:
          "به منظور سهولت و دریافت سریع تر مبلغ در برداشت های بالای ۱۰۰ میلیون تومان، به ازای هر ۱۰۰ میلیون تومان یک شماره شبا متفاوت ثبت کنید.",
        increaseFee: "به ازای هر پرداخت، {amount} ریال کارمزد کسر خواهد شد.",
        depositToSheba: "واریز به شبا",
        depositToCard: "واریز به کارت",
        depositToCardTitle:
          "واریز به کارت آنی | برای برداشت کمتر از ۵۰ میلیون تومان",
        shebaNotCorrect: "شماره شبا وارد شده صحیح نیست.",
        steps: {
          step1: "انتخاب نوع برداشت ریال",
          step2: "انتخاب مقدار مبلغ برداشت"
        }
      }
    }
  },
  exchange: {
    submitOrder: {
      endTime: "مهلت شما برای تکمیل این سفارش به پایان رسید.",
      timeNotice: "مهلت شما برای تکمیل این سفارش",
      payment: "پرداختی",
      received: "دریافتی",
      wage: "کارمزد تبدیل",
      submit: "تایید و ثبت نهایی",
      tryAgain: "بررسی مجدد",
      successText: "سفارش شما با موفقیت ثبت شد.",
      transactionNumber: "شماره تراکنش",
      cancel: "بازگشت",
      goWallet: "رفتن به صفحه کیف پول",
      goTransaction: "رفتن به صفحه تراکنش‌ها",
      goToTransfer: "انتقال به اسپات",
      changePrice: "نرخ تبدیل"
    },
    to: "exchange",
    title: "تبدیل",
    inventory: "موجودی",
    youPay: "پرداخت می‌کنید",
    receive: "دریافت می‌کنید",
    youPayModalTitle: "انتخاب ارز پرداختی",
    youPayModalPlaceholder: "جستجو براساس نام ارز و یا نام اختصاری...",
    receiveModalTitle: "انتخاب ارز دریافتی",
    receiveModalPlaceholder: "جستجو براساس نام ارز و یا نام اختصاری...",
    btn: {
      half: "نصف",
      all: "همه",
      min: "حداقل"
    },
    submit: "ثبت سفارش",
    symbol: "نماد",
    property: "دارایی",
    currenciesAutoComplete: {
      searchPlaceholder: "جستجو بر اساس نام ارز و نام اختصاصی...",
      notFound: "نتیجه‌ای یافت نشد."
    },
    exchangeInput: {
      thereIsNoCoin: "ارزی موجود نیست",
      approximately: "تقریبا"
    },
    balanceNotEnough: "موجودی کیف پول شما کافی نیست.",
    maxReceive: "حداکثر مقدار دریافتی {amount} است.",
    minReceive: "انتقال مقدار دریافتی {amount} است."
  },
  transfer: {
    to: "transfer",
    title: "انتقال",
    transferHistoryTitle: "تاریخچه انتقال‌ها",
    transferToMarket: "انتقال به اسپات",
    acceptOrder: "",
    continueProcess: "ادامه فرآیند انتقال",
    haveNotAcceptRules: "هنوز قوانین اکسکوینو مارکت را نپذیرفتید",
    acceptRulesText:
      "کاربر گرامی، برای کار با بخش اکسکوینو مارکت باید ابتدا قوانین این بخش را بپذیرید. برای اینکار به بخش اکسکوینو مارکت رفته و بعد از مطالعه قوانین و پیذیرفتن آن، مجدد برای انتقال رمز ارز به این صفحه باز گردید.",
    goToMarket: "رفتن به اکسکوینو مارکت",
    balanceNotEnought: "موجودی کیف پول شما کافی نیست.",
    maxTransfer: "حداکثر مقدار قابل برداشت {amount} است.",
    minTransfer: "حداقل مقدار قابل برداشت {amount} است.",
    confirmOrder:
      'ضمن انجام این سفارش تایید میکنم <a href="{url}" target="_blank" class="font-Bold-12 gray1--text crypto-link">قوانین سایت اکسکوینو</a> را مطالعه کرده و می پذیرم.'
  },
  routeQueryTypes: [
    {
      query: "IRR",
      tooltip: "ریال"
    },
    {
      query: "cryptoCurrency",
      tooltip: "رمزارز"
    }
  ],
  excoinoRulesFirstPart: "ضمن انجام این تراکنش تایید میکنم",
  excoinoRulesLink: "قوانین سایت اکسکوینو",
  excoinoRulesSecondPart: "را مطالعه و می‌پذیرم.",

  cartToCart: {
    title: "ثبت اطلاعات واریز کارت به کارت آنلاین",
    cartNumberTitle: "شماره کارت مقصد",
    hint: "تاریخچه واریز کارت به کارت آنلاین",
    tableHeader: "تاریخچه واریز کارت به کارت آنلاین"
  }
};
